import React from "react";
import NextImage from "next/image";
import PropTypes from "prop-types";

function HfnImage(props) {
  const {
    data: { attributes },
    imageIndex,
  } = props;

  if (!attributes) {
    return null;
  }
  const { name, url, alternativeText, height, width } = attributes;
  return (
    <NextImage
      priority={imageIndex !== undefined ? imageIndex === 0 : true}
      src={url}
      alt={alternativeText || name}
      className="img-fluid"
      height={height}
      width={width}
    />
  );
}

HfnImage.propTypes = {
  /**
   * Data for Image component
   * */
  data: PropTypes.shape({
    attributes: PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      alternativeText: PropTypes.string.isRequired,
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  imageIndex: PropTypes.number.isRequired,
};

export default HfnImage;
